<template>
  <div class="py-16" :class="{ 'bg-putty': backgroundGray }">
    <div class="container">
      <div class="text-center mb-10">
        <h2 v-if="heading" class="fluid-3xl leading-tightest" v-html="heading"></h2>
        <div
          v-if="body"
          class="text-copy fluid-base leading-relaxed font-light max-w-3xl mx-auto mt-5"
          data-testid="body"
          v-html="body"
        ></div>
      </div>
      <div class="grid grid-cols-2 md:grid-cols-3 gap-2 md:gap-10 w-full md:w-4/5 mx-auto">
        <div v-for="item in grid" :key="item.id" class="relative group">
          <FixedAspect :ratio="1">
            <CldnImg
              v-if="item.image && item.image[0]"
              :src="item.image[0].url"
              :alt="item.alt ? item.alt : item.image[0].url"
              sizes="50vw sm:20vw md:20vw lg:32vw xl:20vw"
              class="max-w-none block w-full select-none"
            />
          </FixedAspect>
          <div
            class="overlay bg-blackly/80 absolute inset-0 flex flex-col justify-between p-6 transition-opacity opacity-0 group-hover:opacity-100"
          >
            <div
              v-if="item.heading"
              class="fluid-lg leading-none font-medium text-br-green-light break-words"
              v-html="item.heading"
            ></div>
            <div
              v-if="item.body"
              class="bottom-0 fluid-base leading-relaxed font-light text-white break-words"
              v-html="item.body"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CldnImg from '@/components/CldnImg';
import FixedAspect from '@/components/common/FixedAspect';

export default defineNuxtComponent({
  name: 'CampaignGrid',
  components: {
    CldnImg,
    FixedAspect,
  },
  props: {
    heading: {
      type: String,
      default: null,
    },
    body: {
      type: String,
      default: null,
    },
    backgroundGray: {
      type: Boolean,
      default: false,
    },
    grid: {
      type: Array,
      default: () => [],
    },
  },
});
</script>
